module.exports = __webpack_public_path__ + "static/media/apple_logo.85fe5ad2.svg";